<template>
	<div class="login">
		<transition name="fade">
			<div class="app-loader">
				<img src="./../../assets/cndef-loader.gif" alt="Cargando...">
			</div>
		</transition>
		<div class="login-container">
			<div class="login-left">
				<div class="tiras-top">
					<div class="tira-azul"></div>
					<div class="tira-roja"></div>
				</div>
				<div class="login-form">
					<router-link :to="{ name: 'home' }" class="logo">
						<img src="../../assets/LogoNacionalTickets.svg" alt="Nacional Tickets">
						<span>Nacional<br>Tickets</span>
					</router-link>
					<h1>Iniciar sesión</h1>
					<p>Proporciona tus datos para iniciar sesión</p>
					<div class="login-errors" v-if="$store.state.erroresLogin.length">
						<ul>
							<li>{{ this.$store.state.erroresLogin[0].msg }}</li>
						</ul>
					</div>
					<form action="" @submit.prevent="login" novalidate="true">
						<div class="input-group">
							<label for="email">Correo electrónico</label>
							<input tabindex="1" type="email" name="email" id="email" class="no-icon" placeholder="prudencio@reyes.com" v-model="email">
							<!-- <at-sign-icon></at-sign-icon> -->
						</div>
						<div class="input-group">
							<label for="password">Contraseña</label>
							<div class="input-group-input">
								<input tabindex="2" :type="btnPasswordType" name="password" id="password" placeholder="" v-model="password">
								<button type="button" class="togglePassword no-icon" tabindex="-1" @click.prevent="togglePassword"><eye-icon class="password-show" v-if="!showPassword"></eye-icon><eye-off-icon class="password-hide" v-else></eye-off-icon></button>
							</div>
							<!-- <key-icon></key-icon> -->
						</div>
						<div class="input-row">
							<div class="forgot-password">
								<router-link :to="{ name: 'olvide-password' }" tabindex="3"><lock-icon></lock-icon>Olvidé mi contraseña</router-link>
							</div>
						</div>
						<div class="input-row">
							<!-- <button type="submit" tabindex="3">Iniciar sesión</button> -->
							<VueLoadingButton type="submit" tabindex="3" aria-label="Post message" :loading="isLoadingBoton">Iniciar sesión</VueLoadingButton>
						</div>
						<!-- <div class="input-row">
							
						</div> -->
						<!-- <div class="or">
							<span>o</span>
						</div>
						<div class="input-row">
							<div class="login-social login-facebook">
								<img src="../../assets/facebook.png" alt="Facebook">Continuar con Facebook
							</div>
							<div class="login-social login-google">
								<svg xmlns="http://www.w3.org/2000/svg" width="17px" height="17px" viewBox="0 0 16.677 17"><path d="M68.579,55.29l-.086-.364H60.584v3.348h4.725a4.73,4.73,0,0,1-4.627,3.556,5.533,5.533,0,0,1-3.724-1.484,5.316,5.316,0,0,1-1.586-3.752,5.483,5.483,0,0,1,1.557-3.748,5.3,5.3,0,0,1,3.7-1.447,4.825,4.825,0,0,1,3.147,1.226l2.379-2.367a8.417,8.417,0,0,0-5.6-2.158A8.391,8.391,0,0,0,52,56.6,8.541,8.541,0,0,0,54.326,62.5a8.873,8.873,0,0,0,6.4,2.6,7.891,7.891,0,0,0,5.747-2.416,8.486,8.486,0,0,0,2.207-5.878,9.788,9.788,0,0,0-.1-1.516Z" transform="translate(-52 -48.1)" fill="currentColor"></path></svg>Continuar con Google
							</div>
						</div> -->
					</form>
					<div class="registrarse">
						<span>¿Aún no tienes una cuenta?</span>
						<router-link :to="{name: 'registro' }">Regístrate</router-link>
					</div>
				</div>
				<div class="footer">
					<span>Club Nacional de Football © {{ new Date().getFullYear() }}</span>
				</div>
			</div>
			<auth-right></auth-right>
		</div>
	</div>
</template>

<script>
	import VueLoadingButton from 'vue-loading-button'
	import { LockIcon, EyeIcon, EyeOffIcon } from 'vue-feather-icons'
	import AuthRight from '../../components/Shared/AuthRight.vue'

	export default {
		name: 'login',
		data() {
			return {
				email: '',
				password: '',
				btnPasswordType: 'password',
				showPassword: false,
				isLoadingBoton: false
			}
		},
		components: {
			'auth-right': AuthRight,
			LockIcon,
			EyeIcon,
			EyeOffIcon,
			VueLoadingButton
		},
		beforeCreate(){
			window.location.href = process.env.VUE_APP_URL_NACIONALUY;

			// if(this.$store.getters.loggedIn === true){
			// 	this.$router.push({ name: 'home' })
			// }
		},
		methods: {
			async login() {
				this.isLoadingBoton = true;
				this.$store.commit('limpiarErroresLogin');

				if(!this.email && !this.password){
					this.$store.commit('insertarErrorLogin', 'Completa los campos');
					this.isLoadingBoton = false;
				} else {
					if (!this.email){
						this.$store.commit('insertarErrorLogin', 'Debes ingresar un correo electrónico');
						this.isLoadingBoton = false;
					} else {
						if(!this.validarEmail(this.email)){
							this.$store.commit('insertarErrorLogin', 'Correo electrónico no válido');
							this.isLoadingBoton = false;
						} else {
							if (!this.password){
								this.$store.commit('insertarErrorLogin', 'Debes ingresar una contraseña');
								this.isLoadingBoton = false;
							} else {
								await this.$store.dispatch('retrieveToken', {
									email: this.email,
									password: this.password
								})
								.then(response => {
									this.isLoadingBoton = false;
									this.$router.push({ name: 'home' })
								})
								.catch(error => {
									this.isLoadingBoton = false;
								})
							}
						}
					}
				}
			},
			togglePassword() {
				if(this.btnPasswordType === 'password') {
					this.btnPasswordType = 'text'
					this.showPassword = true
				} else {
					this.btnPasswordType = 'password'
					this.showPassword = false
				}
			},
			validarEmail(email) {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(email);
			}
		}
	}
</script>

<style lang="scss">
	.spinner{
		top: calc(50% - 3px) !important;
	}

	.spinner span{
		border-width: 2px !important;
		border-color: #fff transparent transparent transparent !important;
	}
</style>

<style scoped lang="scss">
	@import '../../styles/typography.scss';
	@import '../../styles/mixins.scss';

	.login{
		height: 100%;
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;

		.login-container{
			width: 100%;
			height: 100vh;
			@include flex(row, space-betweeen, center);
			position: relative;
			padding: 0;

			.login-left{
				position: relative;
				width: 800px;
				height: 100vh;
				padding: 0px 24px;
				margin: 0;
				@include flex(column, space-between, center);

				.login-form{
					margin: 0;
					padding: 0;
					width: 100%;
					max-width: 450px;

					.logo{
						@include flex(row, flex-start, center);
						margin: 0;
						margin-bottom: 15px;
						text-decoration: none;
						color: #c61431;
						max-width: 150px;

						img{
							height: 36px;
							width: auto;
							margin-right: 15px;
						}

						span{
							// font-family: 'Bungee', sans-serif;
							font-size: 17px;
							color: #c61431;
							line-height: 1.2em;
						}

						&:hover{
							text-decoration: none;
						}
					}

					h1{
						font-size: 28px;
						margin: 0;
						margin-top: 15px;
						font-weight: 300;
						color: #29355c;
						display: inline-block;
					}

					p{
						margin: 10px 0;
						margin-top: 0;
						// color: rgba(23, 46, 132, 0.8);
						color: #29355c;
						font-size: 14px;
					}

					.login-errors{
						@include flex(row, flex-start, center);
						width: 100%;
						padding: 0;
						margin: 10px 0;

						ul{
							list-style: none;
							margin: 0;
							padding: 0;

							li{
								width: 100%;
								font-size: 13px;
								font-weight: 700;
								color: #c61431;
								line-height: 1.5em;
							}
						}
					}

					form{
						width: 100%;
						@include flex(column, flex-start, flex-start);

						.input-group{
							width: 100%;
							margin: 8px 0;
							position: relative;
							@include flex(column, flex-start, flex-start);

							.input-group-input{
								width: 100%;
								margin: 0;
								padding: 0;
								position: relative;

								svg{
									color: rgba(48, 62, 103, 0.5);
									width: 18px;
									height: 18px;
									position: absolute;
									top: 50%;
									left: 15px;
									transform: translateY(-50%);
								}
							}

							// svg{
							// 	color: rgba(48, 62, 103, 0.5);
							// 	width: 18px;
							// 	height: 18px;
							// 	position: absolute;
							// 	top: 33px;
							// 	left: 15px;
							// }

							label{
								margin-bottom: 4px;
								font-weight: 600;
								color: #29355c;
								font-size: 13px;
							}

							input{
								width: 100%;
								outline: none;
								border: 1px solid #e6e6e6;
								border-radius: 4px;
								padding: 12px 14px 12px 42px;
								// padding: 12px 14px;
								font-size: 13px;
								background-color: #fff;
								box-shadow: none;
								transition: all .2s;
								color: #29355c;
								@include sinApariencia();

								&:focus{
									background-color: #fff;
									border: 1px solid #007bff;
								}

								&.no-icon{
									padding-left: 14px;
								}

								&#password{
									padding: 12px 42px 12px 14px;
								}
							}

							.togglePassword{
								position: absolute;
								top: 50%;
								transform: translateY(-50%);
								right: 15px;
								left: auto;
								width: 18px;
								height: 18px;
								padding: 0;
								background-color: transparent;
								background: none;
								@include flex(row, center, center);

								svg{
									color: rgba(48, 62, 103, 0.5);
									margin: 0;
									width: 18px;
									height: 18px;
									stroke-width: 2px;
									top: inherit;
									left: inherit;
								}

								&:focus{
									svg{
										color: #007bff;	
									}
								}
							}
						}

						.input-row{
							margin: 10px 0;
							width: 100%;
							padding: 0;
							@include flex(row, space-between, center);
						}

						// .login-social{
						// 	width: 50%;
						// 	border: 1px solid rgba(0,0,0,.1);
						// 	padding: 0px 12px;
						// 	border-radius: 99px;
						// 	height: 40px;
						// 	@include flex(row, flex-start, center);
						// 	cursor: pointer;
						// 	font-weight: 600;
						// 	font-size: 14px;
						// 	line-height: 0em;
						// 	transition: all .2s;

						// 	svg, img{
						// 		width: 20px;
						// 		height: auto;
						// 		margin-right: 12px;
						// 		transition: all .2s;
						// 	}

						// 	&.login-facebook{
						// 		margin-right: 7px;
						// 		color: #fff;
						// 		border-color: #4267b2;
						// 		background-color: #4267b2;
						// 	}

						// 	&.login-google{
						// 		margin-left: 7px;
						// 		color: #fff;
						// 		border-color: #4285f4;
						// 		background-color: #4285f4;
						// 	}

						// 	&:hover{
						// 		opacity: 0.9;
						// 	}
						// }

						button{
							width: 100%;
							margin: 0;
							padding: 13px;
							background-color: #11244d;
							color: #fff;
							font-weight: 400;
							font-size: 12px;
							text-transform: uppercase;
							letter-spacing: 2px;
							outline: none;
							border: none;
							border-radius: 5px;
							cursor: pointer;
							transition: all .2s;

							&:hover{
								background-color: #c61431;
							}

							&:disabled{
								color: rgba(27, 46, 75, 0.9);
								background-color: #ddd;
								cursor: not-allowed;
							}
						}

						.forgot-password{
							@include flex(row, flex-start, center);

							a{
								color: #007bff;
								transition: all .2s;
								font-size: 14px;
								line-height: 1.4em;
								@include flex(row, center, center);

								&:focus{
									outline: none;
									opacity: 0.9;
								}
							}

							svg{
								width: 14px;
								height: 14px;
								margin-right: 5px;
								margin-bottom: 1px;
							}
						}

						// .or{
						// 	width: 100%;
						// 	margin: 8px 0;
						// 	position: relative;
						// 	@include flex(row, center, center);

						// 	&:after{
						// 		content: '';
						// 		display: block;
						// 		position: absolute;
						// 		top: 0;
						// 		bottom: 0;
						// 		height: 1px;
						// 		background: rgba(0, 0, 0, 0.1);
						// 		margin: auto;
						// 		width: 100%;
						// 	}

						// 	span{
						// 		padding: 10px;
						// 		z-index: 9;
						// 		background-color: #fff;
						// 		line-height: 1em;
						// 		color: rgba(0, 0, 0, 0.5);
						// 	}
						// }
					}

					.registrarse{
						width: 100%;
						@include flex(row, center, center);
						padding: 10px 0;

						span{
							font-weight: 300;
							font-size: 14px;
							margin-right: 3px;
						}

						a{
							font-weight: 500;
							font-size: 14px;
							margin-left: 3px;

							&:focus{
								outline: none;
							}
						}
					}
				}

				.tiras-top{
					height: 50px;
					width: 30px;
					background-color: #fff;
					margin-bottom: 40px;
					@include flex(row, space-between, center);

					.tira-azul{
						background-color: #172e84;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}

					.tira-roja{
						background-color: #c61431;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}
				}

				.footer{
					width: 100%;
					padding: 20px 0;
					@include flex(column, center, center);

					span{
						font-weight: 400;
						font-size: 12px;
						line-height: 1em;
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and (max-width: 1360px){
		.login{
			.login-container{
				.login-left{
					width: 700px;
				}

				.auth-right{
					width: calc(100% - 700px);
				}
			}
		}
	}

	@media screen and (max-width: 1260px){
		.login{
			.login-container{
				.login-left{
					width: 600px;
					
					.login-form{
						max-width: 380px;
					}
				}

				.auth-right{
					width: calc(100% - 600px);
					background-size: auto;
				}
			}
		}
	}

	@media screen and (max-width: 960px){
		.login{
			.login-container{
				.login-left{
					width: 100%;
					
					.login-form{
						max-width: 450px;
					}
				}

				.auth-right{
					display: none;
				}
			}
		}
	}
</style>